export function validateTCKimlik(tc) {
  if (!tc || typeof tc !== 'string') return { valid: false, error: 'TC Kimlik No gerekli' };
  if (tc.length !== 11) return { valid: false, error: 'TC Kimlik No 11 haneli olmalı' };
  if (!/^\d{11}$/.test(tc)) return { valid: false, error: 'TC Kimlik No sadece rakam içermeli' };
  if (tc[0] === '0') return { valid: false, error: 'TC Kimlik No 0 ile başlayamaz' };

  const d = tc.split('').map(Number);
  const sum1 = d[0] + d[2] + d[4] + d[6] + d[8];
  const sum2 = d[1] + d[3] + d[5] + d[7];
  const digit10 = (sum1 * 7 - sum2) % 10;
  const totalSum = d.slice(0, 10).reduce((a, b) => a + b, 0);
  const digit11 = totalSum % 10;

  if (digit10 !== d[9]) return { valid: false, error: 'TC Kimlik No geçersiz' };
  if (digit11 !== d[10]) return { valid: false, error: 'TC Kimlik No geçersiz' };

  return { valid: true, error: null };
}
